<label class="vue-labelled-checkbox-root" @click="toggle"><CheckboxIcon class="checkbox" :checked="modelValue"></CheckboxIcon>
<Label tag="div" :text="label"></Label></label>